module.exports = __webpack_public_path__ + "static/angelika-behrenberg-37b6aa9462923c07c522aca748f03913.jpg";